(() => {
  const SELECTOR =
    '[data-digi-first-purchase-hero] [data-connectif-form]';

  const FORM_CONTENT_SELECTOR =
    'form, input, select, textarea, button';

  const SUCCESS_SELECTOR =
    '[data-connectif-success]';

  function initConnectif(container) {
    if (
      !container ||
      container.dataset.connectifReady === 'true'
    ) {
      return;
    }

    container.dataset.connectifReady = 'true';

    const hero = container.closest(
      '[data-digi-first-purchase-hero]'
    );

    const loader = container.querySelector(
      '[data-connectif-loader]'
    );

    const updateState = () => {
      const hasContent = Boolean(
        container.querySelector(FORM_CONTENT_SELECTOR)
      );

      const hasSuccess = Boolean(
        container.querySelector(SUCCESS_SELECTOR)
      );

      if (hasContent || hasSuccess) {
        container.classList.add('is-loaded');

        if (loader) {
          loader.setAttribute('aria-hidden', 'true');
        }
      }

      if (hero) {
        hero.classList.toggle(
          'has-connectif-success',
          hasSuccess
        );
      }
    };

    updateState();

    /*
     * O observer permanece ativo porque o ConnectIF primeiro
     * injeta o formulário e depois substitui seu conteúdo
     * pelo resultado do cadastro.
     */
    const observer = new MutationObserver(updateState);

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  function initAllConnectif(scope = document) {
    scope
      .querySelectorAll(SELECTOR)
      .forEach(initConnectif);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAllConnectif(),
      { once: true }
    );
  } else {
    initAllConnectif();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllConnectif(event.target);
    }
  );
})();